import { Link } from "react-router-dom";
import { gossipCategories } from "@/mocks/gossipCategories";
import { SITE_EMAIL, SITE_SLOGAN } from "@/utils/site";

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto grid max-w-shell gap-10 px-4 py-14 md:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              瓜
            </span>
            <span className="font-heading text-lg font-bold text-background-50">瓜料动态</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200">{SITE_SLOGAN}</p>
          <p className="mt-3 text-sm leading-relaxed text-background-300">
            把散落各处的圈内消息整理成一条可滚动的时间线，帮你快速跟上最新进展。
          </p>
        </div>

        <div>
          <h2 className="font-heading text-base font-bold text-background-50">栏目导航</h2>
          <ul className="mt-4 space-y-2.5">
            {gossipCategories.map((category) => (
              <li key={category.slug}>
                <Link
                  to={`/category/${category.slug}`}
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {category.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-base font-bold text-background-50">站内导航</h2>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/" className="text-sm text-background-200 transition-colors hover:text-background-50">
                首页
              </Link>
            </li>
            <li>
              <Link to="/#hot" className="text-sm text-background-200 transition-colors hover:text-background-50">
                热搜榜
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-sm text-background-200 transition-colors hover:text-background-50">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-background-200 transition-colors hover:text-background-50">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-heading text-base font-bold text-background-50">联系我们</h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            发现线索、内容纠错或合作沟通，都欢迎写信给我们。
          </p>
          <a
            href={`mailto:${SITE_EMAIL}`}
            className="mt-3 inline-flex items-center gap-2 text-sm text-background-50 transition-colors hover:text-secondary-200"
          >
            <i className="ri-mail-line text-base" />
            {SITE_EMAIL}
          </a>
          <p className="mt-4 text-xs leading-relaxed text-background-300">
            内容以公开信息整理为主，具体进展请以官方发布为准。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex max-w-shell flex-col gap-2 px-4 py-5 text-xs text-background-300 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2026 瓜料动态 · 内容仅供交流参考</p>
          <p>本站为资讯整理平台，不提供任何形式的交易服务</p>
        </div>
      </div>
    </footer>
  );
}